import { forwardRef, useImperativeHandle, useState } from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import * as Icon from 'react-icons/md';

const CustomeToast = (props, ref) => {
    const [isShow, setToastVisible] = useState(false);
    const [error, setError] = useState("");

    useImperativeHandle(ref, () => ({
        showToast: (error: string) => {
            setError(error);
            setToastVisible(true);
        }
    }));

    const hideToast = () => {
        console.log("hide toast");
        setToastVisible(false);
    }

    return (
        <ToastContainer className="p-3" position={"top-end"}>
            <Toast show={isShow} onClose={hideToast}>
                <Toast.Header>
                    <Icon.MdError size={24} />
                    <strong className="me-auto">Error</strong>
                    <small>1 mins ago</small>
                </Toast.Header>
                <Toast.Body>{error}</Toast.Body>
            </Toast>
        </ToastContainer>
    );
}

export default forwardRef(CustomeToast);